import React from "react";

/**
 * Reusable close button component for modals, popups, and drawer panels.
 *
 * @param {Object} props
 * @param {Function} props.onClick - Click handler function
 * @param {string} [props.size="20px"] - Font size for the icon
 * @param {string} [props.color="#222"] - Color of the close icon
 * @param {string} [props.className=""] - Additional CSS classes
 * @param {Object} [props.style={}] - Additional inline styles
 * @param {string} [props.ariaLabel="Close"] - Accessibility label
 * @param {React.ReactNode} [props.children] - Optional custom icon/content (defaults to fa-solid fa-xmark)
 */
const CloseButton = ({
    onClick,
    size = "20px",
    color = "#222",
    className = "",
    style = {},
    ariaLabel = "Close",
    children,
    ...props
}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            tabIndex={-1}
            className={`btn btn-link p-0 text-dark border-0 shadow-none ${className}`}
            style={{
                fontSize: size,
                lineHeight: "1",
                textDecoration: "none",
                cursor: "pointer",
                color: color,
                outline: "none",
                boxShadow: "none",
                ...style,
            }}
            aria-label={ariaLabel}
            {...props}
        >
            {children || <i className="fa-solid fa-xmark"></i>}
        </button>
    );
};

export default CloseButton;
